import { Dropdown } from 'core-components/library/dropdown'
import { IStaticPropertiesMapping } from 'core-components/sitebuilder/models/IMetaInformation'
import { IStaticProps } from 'core-components/sitebuilder/models/IWidget'
import { useStaticCrud } from 'core-components/types/helpers'

interface IDropdownEditorProps {
  onChange: (newValue: string | boolean | number | IStaticProps[]) => void
  dropdownItems?: IStaticPropertiesMapping['dropdownItems']
  dropdownSource?: IStaticPropertiesMapping['dropdownSource']
  paramName: string
  value: string
  className?: string
}

export const DropdownEditor = ({
  onChange,
  dropdownItems,
  dropdownSource,
  paramName,
  value,
  className,
}: IDropdownEditorProps) => {
  const source = useStaticCrud({ data: dropdownItems || [] })

  if (!dropdownItems && !dropdownSource) {
    console.error(`The list of items is not set for this prop ${paramName}`)
    return null
  }

  return (
    <Dropdown
      classes={{ controlClasses: { root: className } }}
      source={dropdownSource || source}
      label={'Parameter value'}
      onChange={onChange}
      value={value}
      caption={'value'}
    />
  )
}
